import { IAppState } from '../../redux';
import { EServiceId } from '../../redux/reducers';

export const selectIsWithoutTopAndPremium = (state: IAppState): boolean => {
  return !state.publishTerms.serviceIds.some(id => id === EServiceId.top || id === EServiceId.premium);
};
